<template>
  <div class="agent-contact">
    <base-heading>{{ $t('support.agentContact.title') }}</base-heading>
    <transition name="fade" mode="out-in">
      <base-inline-loader v-if="loading" height="430" key="loader"/>
      <validation-observer v-else
                           key="form"
                           tag="form"
                           ref="contactObs"
                           class="contact-form"
                           @submit.prevent="validateContactForm">
        <category-type-field :category-data="$props.userInfo"
                             :label="$t('support.agentContact.categoryLabel')"/>
        <base-v-input v-model.trim="formData.contactPhone"
                      id="phone"
                      name="phone"
                      class="phone-input"
                      ref="phone"
                      variant="white"
                      :submitted="formSubmitted"
                      :label="$t('support.agentContact.phoneLabel')"
                      :placeholder="$t('support.agentContact.phoneLabel')"
                      rules="required|phoneNumberWithSpaces|max:15"
                      maxlength="15"/>
        <base-v-input v-model.trim="formData.email"
                      id="email"
                      name="email"
                      class="email-input"
                      ref="email"
                      variant="white"
                      :submitted="formSubmitted"
                      :label="$t('support.agentContact.emailLabel')"
                      :placeholder="$t('support.agentContact.emailLabel')"
                      rules="required|noSpaces|email"/>
        <base-file-input id="attachment"
                         name="attachment"
                         :placeholder="$t('support.agentContact.attachmentPlaceholder')"
                         class="email-input"
                         ref="attachment"
                         :submitted="formSubmitted"
                         :label="$t('support.agentContact.attachmentLabel')"
                         :error-message="$t('support.agentContact.fileErrorMessage')"
                         :size-error-message="$t('support.agentContact.fileSizeErrorMessage')"
                         :file-types="['.jpg', '.jpeg', '.gif', '.png', '.bmp']"/>
        <label for="message" class="custom-input-label">{{ $t('support.agentContact.messageLabel') }}
          <span>{{ formData.message.length }}/2000</span></label>
        <validation-provider :mode="formSubmitted ? 'eager' : 'passive'"
                             v-slot="{ errors }"
                             tag="div"
                             rules="required|max:2000"
                             vid="poruka"
                             class="message-input">
      <textarea v-model="formData.message"
                id="message"
                name="poruka"
                :placeholder="$t('support.agentContact.messagePlaceholder')"
                :class="{'error': errors.length}">
      </textarea>
          <p class="custom-error-msg" v-if="errors.length">{{ errors[0] }}</p>
        </validation-provider>
        <base-button variant="primary"
                     type="submit"
                     class="contact-submit">
          {{ $t('support.agentContact.sendMessageAction') }}
        </base-button>
      </validation-observer>
    </transition>
  </div>
</template>

<script>
import CategoryTypeField from './agent-contact-subcomponents/category-type-field'
import BaseFileInput from '@/components/base/base-file-input'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import { addDataLayerEvent } from '@/services/dataLayer'

export default {
  name: 'agent-contact',
  components: { BaseFileInput, CategoryTypeField },
  mixins: [errorMessageHandler],
  data () {
    return {
      formData: {
        contactPhone: '',
        email: '',
        message: '',
        customerId: ''
      },
      formSubmitted: false,
      loading: false
    }
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    async validateContactForm () {
      const formValid = await this.$refs.contactObs.validate()
      this.formSubmitted = true
      if (formValid) {
        this.sendContactEmail()
      }
    },
    sendContactEmail () {
      this.loading = true
      const dataToSend = new FormData()
      const objData = {
        ...this.formData,
        file: this.$refs?.attachment?.file
      }
      Object.entries(objData).forEach(([key, value]) => {
        dataToSend.append(key, value)
      })

      this.$apiRequest.post('user/support/sendemail',
        dataToSend,
        { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.toast('success', {
            title: this.$t('support.agentContact.contactAgentSuccessTitle'),
            message: this.$t('support.agentContact.contactAgentSuccessMessage')
          })
          this.formData.message = ''

          addDataLayerEvent({
            customer_type: this.$props.userInfo?.subscriptionInfo?.type,
            attachment_present: this.$refs?.attachment?.file !== null,
            event: 'contact_agent'
          })

          setTimeout(() => {
            this.formSubmitted = false
            this.formData.message = ''
            if (this.$refs?.attachment?.file) this.$refs.attachment.file = null
          }, 250) // wait for transition to be over so $refs is not undefined
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getUserPhone (userData) {
      const userType = userData.subscriptionInfo ? userData.subscriptionInfo.type : ''
      let userPhone = ''
      switch (userType) {
        case 'MOBILE_PREPAID':
        case 'MOBILE_POSTPAID':
        case 'FIXED_TELEPHONY':
        case 'BOX':
          userPhone = userData.formattedContactPhone
          break
        default:
          userPhone = ''
          break
      }
      return userPhone.replace(/[^0-9]/g, '')
    }
  },
  watch: {
    '$props.userInfo': {
      handler (newVal) {
        if (Object.keys(newVal).length) {
          this.formData.email = newVal.userEmail
          this.formData.contactPhone = this.getUserPhone(newVal)
          this.formData.customerId = newVal.subscriptionInfo ? newVal.subscriptionInfo.customerId : ''
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped lang="scss" src="./styles/agent-contact.scss"></style>
